import React from 'react';
import isFunction from 'lodash/isFunction';
import PropTypes from 'prop-types';
import Popover from '../Popover';

import { MenuContainer, MenuItemContainer, MenuItemButton } from './menu.style';

const Menu = ({ target, children, ...rest }) => (
  <Popover
    target={({ targetProps, targetEvents, active }) =>
      React.cloneElement(isFunction(target) ? target({ active }) : target, {
        ...targetProps,
        ...targetEvents,
      })
    }
    {...rest}
  >
    {({ handleClose }) => (
      <MenuContainer>
        {isFunction(children) ? children({ onClose: handleClose }) : children}
      </MenuContainer>
    )}
  </Popover>
);

Menu.propTypes = {
  target: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
};

export const MenuItem = ({ children, onClose, onClick, ...props }) => (
  <MenuItemContainer role="presentation">
    <MenuItemButton role="menuitem" onClick={() => onClick({ onClose })} {...props}>
      {children}
    </MenuItemButton>
  </MenuItemContainer>
);

MenuItem.propTypes = {
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

MenuItem.defaultProps = {
  onClose: () => {},
  onClick: () => {},
};

export default Menu;
